var productData = [
	["FIS EM PLUS 390", 13, 390],
	["FIS EM PLUS 585", 19.5, 585],
	["FIS SB 390", 13, 390],
	["FIS V 300", 10, 300],
	["FIS V 360", 12, 360],
	["FIS V Zero 300", 10, 300]
];

var itemDataM = [
	[8,10,60,160,100,10,8],
	[10,12,60,200,100,20,10],
	[12,14,70,240,100,40,12],
	[16,18,80,320,116,60,16],
	[20,24,90,400,138,120,20],
	[24,28,96,480,152,150,24],
	[27,30,108,540,162,200,27],
	[30,35,120,600,190,300,30]
];
var itemDataF = [
	["3/8", "7/16", "2 3/8", "7 1/2", "3 5/8", 15, .375],
	["1/2", "9/16", "2 3/4", "10", "3 5/8", 30, .5],
	["5/8", "3/4", "3 1/8", "12 1/2", "4 5/8", 50, .625],
	["3/4", "7/8", "3 1/2", "15", "5 1/4", 90, .75],
	["7/8", "1", "3 1/2", "17 1/2", "5 1/2", 100, .875],
	["1", "1 1/8", "4", "20", "6 1/4", 135, 1],
	["1 1/8", "1 1/4", "4 1/2", "22 1/2", "7", 180, 1.125],
	["1 1/4", "1 3/8", "5", "25", "7 3/4", 240, 1.25]
];
var itemDataMR = [
	[10,14,60,200,100,30,10],
	[12,16,70,240,102,50,12],
	[16,20,80,320,116,110,16],
	[20,25,90,400,130,190,20],
	[25,30,100,500,150,280,25],
	[28,35,112,560,168,350,28],
	[32,40,128,640,192,430,32]
];

var itemDataFR = [
    ["3",  "1/2",     "2 3/8", "7 1/2",  "3 5/8", "22", 0.38, 9.53],
	["4",  "5/8",     "2 3/4", "10",     "4",     "44", 0.50, 12.70],
	["5",  "13/16",   "3 1/8", "12 1/2", "4 1/8", "81", 0.63, 15.88],
	["6",  "7/8",     "3 1/2", "15",     "5 1/4", "129", 0.75, 19.05],
	["7",  "1 1/8",   "3 1/2", "17 1/2", "5 3/4", "177", 0.88, 22.23],
	["8",  "1 1/4",   "4",     "20",     "6 1/2", "236", 1.00, 25.40],
	["9",  "1 19/50", "4 1/2", "22 1/2", "7 1/4", "280", 1.13, 28.58],
	["10", "1 23/40", "5",     "25",     "8",     "332", 1.25, 31.75],
	["11", "1 13/20", "5 1/2", "27 1/2", "9",     "332", 1.38, 34.93]
];



var itemData = [];

var rodDiaVal = 0;
var drillDiaVal = 0;

function calc()
{
	var rodDia = document.getElementById("RodDia");
	if (rodDia !== undefined)
	{
		rodDiaVal = RodDia.value * 1;
		var selected = null;
		for(var n = 0; n < itemData.length; n++)
		{
			if (itemData[n][6] === rodDiaVal)
			{
				selected = itemData[n];
				//alert(RodDia.value);
			}
		}
		if (selected !== null)
		{
			var drillDiaVal = selected[1];
			document.getElementById("drildia").value = drillDiaVal; // dia to show
			document.getElementById("hefmin").value = selected[2];
			document.getElementById("hefmax").value = selected[3];
			document.getElementById("insttorq").value = selected[5];
			document.getElementById("matthick").value = selected[4];

			var hefmin = fractionToNormal(selected[2]);
			var hefmax = fractionToNormal(selected[3]);

			var actualHef = fractionToNormal(document.getElementById("acthef").value) * 1;
			if(actualHef < hefmin || actualHef > hefmax)
			{
				var average = Math.floor(((hefmax - hefmin) / 2) + hefmin);
				document.getElementById("acthef").value = average;
			}
			shortCalc();
		}
	}
}

function shortCalc()
{
	var chemicalSelector = document.getElementById("ChemicalSelector").value;
	var volume = 0;
	// get data for chemicalSelector
	for (var n = 0; n < productData.length; n++)
	{
		var cleanUp = productData[n][0].toLowerCase().replace(/\W/ig, "");
		if (chemicalSelector === cleanUp)
		{
			volume = productData[n][2]; // for metric
		}
	}

	var hefmin = fractionToNormal(document.getElementById("hefmin").value);
	var hefmax = fractionToNormal(document.getElementById("hefmax").value);

	var drillDiaVal = fractionToNormal(document.getElementById("drildia").value) * 1;
	var actualHef = fractionToNormal(document.getElementById("acthef").value) * 1;
	var numfix = document.getElementById("numfix").value * 1;

	var boundarywarning = document.getElementById("boundarywarning");
	if(actualHef < hefmin || actualHef > hefmax)
		boundarywarning.classList.add("dowarn");
	else
		boundarywarning.classList.remove("dowarn");

	if (drillDiaVal < rodDiaVal)
	{
		//drillDiaVal = rodDiaVal + 2;
		//document.getElementById("drildia").value = drillDiaVal;
	}

    var anchtype = document.getElementById('typethreaded').checked ? "typethreaded" : "typerebar";
    var calctype = document.getElementById('calcmetric').checked ? "calcmetric" : "calcfractions";

    // do the fraction magic
    var rodDiaValMM = rodDiaVal;
    var drillDiaValMM = drillDiaVal;
    var actualHefMM = actualHef;
    if (calctype === "calcfractions")
    {
      rodDiaValMM = rodDiaVal * 25.4;
      drillDiaValMM = drillDiaVal * 25.4;
      actualHefMM = actualHef * 25.4;
    }
    console.log("drillDiaVal: %f , rodDiaVal: %f, actualHef: %f", drillDiaVal, rodDiaVal, actualHef);
    console.log("drillDiaValMM: %f , rodDiaValMM: %f, actualHefMM: %f", drillDiaValMM, rodDiaValMM, actualHefMM);
	//var mortarVolume = Math.ceil(((((drillDiaVal ** 2) - (rodDiaValMM ** 2)) * actualHef * 1.2 * .785) / 1000) + 5);
	var mortarVolume = (((((drillDiaValMM ** 2) - (rodDiaValMM ** 2)) * actualHefMM * 1.2 * .785) / 1000));
    var fixpercart = 0;
    if (calctype === "calcfractions")
    {
      if (anchtype == "typethreaded")
      {
    	  mortarVolume = (((drillDiaValMM ** 2) - (rodDiaValMM ** 2)) * actualHefMM * 1.25) / 1000 + 3;
      }
      else
      {
    	  mortarVolume = (((drillDiaValMM ** 2) - (rodDiaValMM ** 2)) * actualHefMM * 1.2 * .785) / 1000;
      }
      fixpercart = Math.floor(volume / mortarVolume);
      mortarVolume = mortarVolume * 0.0339;
    }
    else
    {
      if (anchtype == "typethreaded")
      {
        //AFRONDEN.NAAR.BOVEN(((((J6^2)-(L5^2))*J11)*1,2)/1000+5;0)
    	  mortarVolume = Math.ceil((((drillDiaValMM ** 2) - (rodDiaValMM ** 2)) * actualHefMM * 1.2) / 1000 + 5);
      }
      else
      {
    	  mortarVolume = Math.ceil((((drillDiaValMM ** 2) - (rodDiaValMM ** 2)) * actualHefMM * 1.15 * .785) / 1000);
      }
      fixpercart = Math.floor(volume / mortarVolume);
    }
  
  //typerebar typethreaded
console.log("mortarVolume: %f , totmort: %f", mortarVolume, mortarVolume * numfix);
	document.getElementById("volmort").value = Math.round(mortarVolume * 100) / 100;
	document.getElementById("totmort").value = Math.ceil(mortarVolume * numfix);

	if (volume > 0)
	{
		document.getElementById("fixpercart").value = fixpercart;
      //alert(volume);
		//document.getElementById("numcart").value = Math.ceil(numfix / fixpercart);
		document.getElementById("numcart").value = Math.ceil(Math.ceil(mortarVolume * numfix) / volume);
	}
}

function fractionToNormal(fraction)
{
	var clean = (fraction + "").replace(/ +/g, " + ");
	var neat = eval(clean);
	return neat;
}

function setCalcHandler(elm) {
	setCalc(elm.target.id);
}
function setCalc(target) {
    var anchtype = document.getElementById('typethreaded').checked ? "typethreaded" : "typerebar";
    var calctype = document.getElementById('calcmetric').checked ? "calcmetric" : "calcfractions";
  
	var calculatortable = document.getElementById('calculatortable');
    var calculatorcontentimage = document.getElementById('infCalculator_content_image');
    if (anchtype === "typerebar")
    {
      calculatorcontentimage.className = "calctyperebar";
    }
  else if (anchtype === "typethreaded")
  {
      calculatorcontentimage.className = "calctypethreaded";
  }
	if(calctype === "calcmetric")
	{
		calculatortable.className = "calcmetric";
		var rodDiaSelect = document.getElementById('RodDia');
		while (rodDiaSelect.firstChild)
			rodDiaSelect.removeChild(rodDiaSelect.firstChild);
		itemData = [];
        //alert(anchtype);
      var itemDataTemp = itemDataM;
        if (anchtype === 'typerebar')
          itemDataTemp = itemDataMR;
		for(var n = 0; n < itemDataTemp.length; n++)
		{
			var el = document.createElement("option");
			el.textContent = "M" + itemDataTemp[n][0];
			el.value = itemDataTemp[n][0];
			rodDiaSelect.appendChild(el);
            itemData.push(itemDataTemp[n]);
		}
	}
	else if(calctype === "calcfractions")
	{
		calculatortable.className = "calcfractions";
		var rodDiaSelect = document.getElementById('RodDia');
		while (rodDiaSelect.firstChild)
			rodDiaSelect.removeChild(rodDiaSelect.firstChild);

		itemData = [];
      var itemDataTemp = itemDataF;
        if (anchtype === 'typerebar')
          itemDataTemp = itemDataFR;

      for(var n = 0; n < itemDataTemp.length; n++)
		{
			var el = document.createElement("option");
			el.textContent = itemDataTemp[n][0];
			el.value = itemDataTemp[n][6]; //fractionToNormal(itemDataTemp[n][0]);
			rodDiaSelect.appendChild(el);
			var row = [];
			for (var i = 0; i < itemDataTemp[n].length; i++)
			{
				if (i === 0)
					row.push(fractionToNormal(itemDataTemp[n][i]));
				else
					row.push((itemDataTemp[n][i]));
			}
			itemData.push(row);
		}
	}
	calc();
}
var infCalculator = {

  popOverVisible: false, 
  
  formContent: '<table id="calculatortable" class=""><tr><td colspan="2"><input type="radio" id="typethreaded" name="itemtype" class="radiobutton" checked> <label for="typethreaded">Threaded</label> <input type="radio" id="typerebar" name="itemtype" class="radiobutton"> <label for="typerebar">Rebar</label></td></tr><tr><td colspan="2"><input type="radio" id="calcfractions" name="calctype" class="radiobutton" checked> <label for="calcfractions">Standard</label> <input type="radio" id="calcmetric" name="calctype" class="radiobutton"> <label for="calcmetric">Metric</label></td></tr><tr><td colspan="2">&nbsp;</td></tr><tr><td>Chemical product</td><td><select id="ChemicalSelector"><option value="fisemplus390">FIS EM Plus 390 (13.2 Oz)</option><option value="fisemplus585">FIS EM PLUS 585 (19.8 Oz)</option><option value="fissb390">FIS SB 390 (13.2 Oz)</option><option value="fisv300">FIS V 300 (10.1 Oz)</option><option value="fisv360">FIS V 360 (12.2 Oz)</option><option value="fisvzero300">FIS V Zero 300 (10.1 Oz)</option></select></td></tr><tr><td>&Oslash; Rod Dia d<sub>a</sub></td><td><select id="RodDia"><option value="8">M8</option><option value="10">M10</option><option value="12">M12</option><option value="16" selected>M16</option><option value="20">M20</option><option value="24">M24</option><option value="27">M27</option><option value="30">M30</option><option value="44">1&frac14;</option></select></td></tr><tr><td>&Oslash; Drilling Dia d<sub>0</sub></td><td><div class="input-group"><input type="text" class="form-control" id="drildia" readonly><span class="input-group-text ismetric">mm</span><span class="input-group-text isfraction">inch</span></div></td></tr><tr><td>h<sub>ef</sub>,min</td><td><div class="input-group"><input type="text" class="form-control" id="hefmin" readonly><span class="input-group-text ismetric">mm</span><span class="input-group-text isfraction">inch</span></div></td></tr><tr><td>h<sub>ef</sub>,max</td><td><div class="input-group"><input type="text" class="form-control" id="hefmax" readonly><span class="input-group-text ismetric">mm</span><span class="input-group-text isfraction">inch</span></div></td></tr><tr><td>Installation Torque</td><td><div class="input-group"><input type="text" class="form-control" id="insttorq" readonly><span class="input-group-text">Nm</span></div></td></tr><tr><td>Base Material Thickness h<sub>min</sub> for h<sub>ef</sub> Min</td><td><div class="input-group"><input type="text" class="form-control" id="matthick" readonly><span class="input-group-text ismetric">mm</span><span class="input-group-text isfraction">inch</span></div></td></tr><tr><td>Actual h<sub>ef</sub></td><td><div class="input-group"><input type="text" class="form-control" id="acthef" value="160"><span class="input-group-text ismetric">mm</span><span class="input-group-text isfraction">inch</span></div></td></tr><tr><td>Number of fixings</td><td><div class="input-group"><input type="text" class="form-control" id="numfix" value="100" ><span class="input-group-text">&nbsp;</span></div></td></tr><tr><td colspan="2">&nbsp;</td></tr><tr><td>Volume of mortar/ Hole</td><td><div class="input-group"><input type="text" class="form-control" id="volmort" readonly><span class="input-group-text ismetric">ml</span><span class="input-group-text isfraction">Oz</span></div></td></tr><tr><td>Total Mortar Volume</td><td><div class="input-group"><input type="text" class="form-control" id="totmort" readonly><span class="input-group-text ismetric">ml</span><span class="input-group-text isfraction">Oz</span></div></td></tr><tr><td>Number of fixing with 1 Cartridge</td><td><div class="input-group"><input type="text" class="form-control" id="fixpercart" readonly><span class="input-group-text">pc</span></div></td></tr><tr><td>Required Number of Cartridges</td><td><div class="input-group"><input type="text" class="form-control" id="numcart" readonly><span class="input-group-text">pc</span></div></td></tr></table><p>Nominal waste is included in the calculation.</p><p id="boundarywarning">C-Fix Design Recommended, Please contact Fischer Customer Service at email <a href="mailto:engineering@fischerus.com">engineering@fischerus.com</a>.</p>',
  formClose: '<button id="infCalculatorclose" type="button" class="infCalculatorclose-toggle" aria-label="Close"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L19.5303 5.53033ZM4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L4.46967 18.4697ZM5.53034 4.46967C5.23745 4.17678 4.76258 4.17678 4.46968 4.46967C4.17679 4.76256 4.17679 5.23744 4.46968 5.53033L5.53034 4.46967ZM18.4697 19.5303C18.7626 19.8232 19.2375 19.8232 19.5304 19.5303C19.8232 19.2374 19.8232 18.7626 19.5304 18.4697L18.4697 19.5303ZM18.4697 4.46967L4.46967 18.4697L5.53033 19.5303L19.5303 5.53033L18.4697 4.46967ZM4.46968 5.53033L18.4697 19.5303L19.5304 18.4697L5.53034 4.46967L4.46968 5.53033Z" fill="#001A72"></path></svg></button>',
  
  preparePopOver: function() {
      var div = document.createElement("div");
    div.id = 'infCalculator_popover';
    div.style.display = 'none';
    div.role = 'dialog';
    div.ariaModal = 'true';
    div.ariaLabel = 'fischer Anchors Volume Calculator';
    div.tabindex = '-1';

    div.innerHTML = '<div id="infCalculator_overlay" class="infCalculator_overlay"></div><div id="infCalculator_content" class="infCalculator_content"><div id="infCalculator_content_form"></div><div id="infCalculator_content_image"></div></div>';

    document.body.appendChild(div);

    var calculatorDialog = document.getElementById('infCalculator_content_form');
    calculatorDialog.innerHTML = infCalculator.formClose + infCalculator.formContent;
    // handle close
    document.getElementById('infCalculator_overlay').addEventListener('click', infCalculator.handleOverlayClick);
    document.getElementById('infCalculatorclose').addEventListener('click', infCalculator.handleOverlayClick);
    document.addEventListener('keydown', infCalculator.keyDownHandler);

    // get image url
    var imghelper = document.getElementById("calculatorimages");
    if (imghelper != null)
    {
      var contentImage = document.getElementById("infCalculator_content_image");
      var imgrebar = document.createElement("img");
      imgrebar.id="infCalculator_content_imagerebar";
      imgrebar.src=imghelper.dataset.calculatorrebar;
      contentImage.appendChild(imgrebar);
      var imgthreadedrod = document.createElement("img");
      imgthreadedrod.id="infCalculator_content_imagethreadedrod";
      imgthreadedrod.src=imghelper.dataset.calculatorthreadedrod;
      contentImage.appendChild(imgthreadedrod);
    }
    
    
    // handle open
    var allx = document.querySelectorAll('[data-inf-toggle="calculator"]')
    for(var n = 0; n < allx.length; n++)
      {
        allx[n].addEventListener('click', function(ev) {
          ev.preventDefault();
      infCalculator.showPopOver();
    });
      }
  
document.getElementById('typethreaded').addEventListener('change', setCalcHandler);
document.getElementById('typerebar').addEventListener('change', setCalcHandler);
document.getElementById('calcfractions').addEventListener('change', setCalcHandler);
document.getElementById('calcmetric').addEventListener('change', setCalcHandler);
    
document.getElementById('RodDia').addEventListener('change', calc);
document.getElementById('ChemicalSelector').addEventListener('change', shortCalc);
document.getElementById('acthef').addEventListener('change', shortCalc);
document.getElementById('numfix').addEventListener('change', shortCalc);
document.getElementById('drildia').addEventListener('change', shortCalc);
setCalc("calcmetric");
calc();

    
    
  },
  keyDownHandler: function(ev) {
    if(ev.key == 'Escape')
      infCalculator.hidePopOver();
  },
  showPopOver: function() {
   // console.log(document.documentElement.scrollTop);
    if (infCalculator.popOverVisible == false)
    {
      infCalculator.popOverVisible = true;
      document.body.style.overflow = "hidden";
      document.getElementById('infCalculator_popover').style.top = document.documentElement.scrollTop + "px";
      document.getElementById('infCalculator_popover').style.display = "block";
    }
    
  },
  hidePopOver: function() {
    if (infCalculator.popOverVisible == true)
    {
      infCalculator.popOverVisible = false;
      document.body.style.overflow = null;
      document.getElementById('infCalculator_popover').style.display = "none";
    }
  },
  handleOverlayClick: function(ev) {
    infCalculator.hidePopOver();
  }
  
}
infCalculator.preparePopOver();
